module.exports = __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-5380673.e687a1bd.jpg";